import * as _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { IUserInfo } from '../models/IUserInfo';
import { IUserWithImage } from '../ServerApi/types/IUser';

export module UserWithImageMapper {

  export function map(serverApiUsers: IUserWithImage[]): IUserInfo[] {
    return _.map(serverApiUsers, mapOne);
  }

  export function mapOne(u: IUserWithImage): IUserInfo {
    if (u == null) {
      u = {
        displayName: Messages.hiddenUser(),
        username: '',
        id: '0',
        isHiddenInternalUser: true
      };
    }
    return {
      authId:                 u.authId,
      displayName:            u.displayName,
      domainName:             u.domainName,
      id:                     u.id,
      isHiddenInternalUser:   u.isHiddenInternalUser || false,
      readOnly:               u.readOnly,
      username:               u.username,
      userImageUrl:           u.userImageUrl
    };
  }

}
